import System from '../../basic/System';
import Authenticator from '../../protocol/Authenticator';
import PreviewServerUrlGenerator from '../preview/PreviewServerUrlGenerator';
import ThumbnailUtil from '../ThumbnailUtil';

export default class ConnectionUtil {
  static getBaseUrl(): string {
    return window.baseApiUrl;
  }

  static getReviewLogoutUrl(url = ConnectionUtil.getPreviewServerUrl()): string {
    return url + ConnectionUtil.REVIEW_LOGOUT_URL_SUFFIX;
  }

  static getReviewAuthUrl(url = ConnectionUtil.getPreviewServerUrl()): string {
    return url + ConnectionUtil.REVIEW_AUTH_URL_SUFFIX;
  }

  static getAppAuthURL(): string {
    return ConnectionUtil.getBaseUrl() + ConnectionUtil.getAppAuthUrlSuffix();
  }

  static getAppAuthUrlSuffix(): string {
    if (System.isBrowserApp()) {
      return ConnectionUtil.WEBCLIENT_AUTH_URL_SUFFIX;
    } else {
      return '';
    }
  }

  static getPreviewServerCheckAuthURL(url = ConnectionUtil.getPreviewServerUrl()) {
    return url + ConnectionUtil.REVIEW_AUTH_CHECK_URL;
  }

  static getActualBaseURL() {
    return System.isBrowserApp() ? window.location.origin : PreviewServerUrlGenerator.getCurrentPreviewServerUrl();
  }

  static getPreviewServerUrl() {
    return System.isBrowserApp() ? ConnectionUtil.getBaseUrl() : PreviewServerUrlGenerator.getCurrentPreviewServerUrl();
  }

  static getOAuthUrl() {
    const relamendPoint = System.isBrowserApp() ? '/webclient/oauthlogin' : '/webmin/vabremoting';
    return ConnectionUtil.getBaseUrl() + relamendPoint;
  }

  static getUnSecureURLCall() {
    return System.getUnSecureURLCallFromMap();
  }

  static getSecureURLCall(queryName: string) {
    let secureSystemCall = System.getSecureURLCallFromMap();
    return System.isBrowserApp() ? secureSystemCall + queryName : secureSystemCall;
  }

  static getUserId() {
    return Authenticator.AUTH_DATA.username;
  }

  static getAvatarUploadURL() {
    if (System.isBrowserApp()) {
      return ConnectionUtil.getPreviewServerUrl() + ThumbnailUtil.AVATAR_UPLOAD_PATH;
    } else {
      return (
        ConnectionUtil.getBaseUrl() +
        ConnectionUtil.DESKTOP_CONTEXT +
        ConnectionUtil.SECURE_REMOTE_CALL_SUFFIX +
        '/clientapi/user/avatar-upload'
      );
    }
  }

  static REVIEW_AUTH_CHECK_URL: string = '/review/api/me';
  static REVIEW_LOGOUT_URL_SUFFIX: string = '/review/api/logout';
  static REVIEW_AUTH_URL_SUFFIX: string = '/review/j_security_check';
  static WEBCLIENT_AUTH_URL_SUFFIX: string = '/webclient/j_security_check';
  static UNSECURE_REMOTE_CALL_SUFFIX: string = '/jsp/client/json_remote.jsp';
  static SECURE_REMOTE_CALL_SUFFIX: string = '/vabremoting';
  static DESKTOP_CONTEXT: string = '/webmin';
  static UNSECURE_REMOTE_CALL_URL = 'unsecure_remote_call_url';
  static SECURE_REMOTE_CALL_URL = 'secure_remote_call_url';
}
